export default {
  SET_DIALOG: 'SET_DIALOG',
  SET_EMPLOYEE_FORM_STATE: 'SET_EMPLOYEE_FORM_STATE'
};
